"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _jQuery = _interopRequireDefault(require("jQuery"));

var _underscore = require("underscore");

var _reactRedux = require("react-redux");

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _reactRouterRedux = require("react-router-redux");

var _AppHeader = _interopRequireDefault(require("../components/AppHeader"));

var _UIListingPage = _interopRequireDefault(require("UIComponents/page/UIListingPage"));

var _DirectoryPage = _interopRequireDefault(require("../components/DirectoryPage"));

var _SearchBarContainer = _interopRequireDefault(require("./SearchBarContainer"));

var _GoodSubTypes = _interopRequireDefault(require("../constants/GoodSubTypes"));

var _GoodSubTypeGroups = _interopRequireDefault(require("../constants/GoodSubTypeGroups"));

var _HeaderTabs = _interopRequireDefault(require("../constants/HeaderTabs"));

var _GoodFiltersAndPage = _interopRequireDefault(require("../constants/GoodFiltersAndPage"));

var _GoodsActions = require("../actions/GoodsActions");

var _utils = require("../utils/utils");

var _constants = require("../lib/usage/constants");

var _withUsageTracking = _interopRequireDefault(require("./hocs/withUsageTracking"));

var _redux = require("redux");

var DirectoryContainer = _react.default.createClass({
  displayName: "DirectoryContainer",
  propTypes: {
    auth: _react.PropTypes.object.isRequired,
    categoryFilter: _react.PropTypes.string.isRequired,
    directoryData: _react.PropTypes.object.isRequired,
    getGoodsWithFilterAndPageParamsFromUrl: _react.PropTypes.func.isRequired,
    location: _react.PropTypes.object.isRequired,
    replace: _react.PropTypes.func.isRequired,
    trackAdjustedFilter: _react.PropTypes.func.isRequired,
    trackClickedLink: _react.PropTypes.func.isRequired,
    trackPageview: _react.PropTypes.func.isRequired,
    updatePage: _react.PropTypes.func.isRequired,
    updateGoodFilters: _react.PropTypes.func.isRequired
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    var location = this.props.location;
    var query = location.query;
    document.title = _I18n.default.text('MarketplaceUI.directory.documentTitle');

    if (query.subType === _GoodSubTypeGroups.default.PAGE_TEMPLATES) {
      this.props.replace((0, _extends2.default)({}, location, {
        query: (0, _extends2.default)({}, query, {
          subType: _GoodSubTypes.default.SITE_PAGES
        })
      }));
      return;
    }

    this.props.getGoodsWithFilterAndPageParamsFromUrl((0, _utils.parseQueryParamsForMultiselectFilters)((0, _utils.getQueryParamsWithParsedInt)(query)), true, "directory-" + (query.subType || 'all-categories'));
  },
  componentDidMount: function componentDidMount() {
    this.props.trackPageview(_constants.Screens.DIRECTORY);
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    var currentQuery = this.props.location.query;
    var nextQuery = nextProps.location.query;

    if (!(0, _underscore.isEqual)(currentQuery, nextQuery)) {
      this.props.getGoodsWithFilterAndPageParamsFromUrl((0, _utils.parseQueryParamsForMultiselectFilters)((0, _utils.getQueryParamsWithParsedInt)(nextProps.location.query)), currentQuery.subType !== nextQuery.subType);
    }
  },
  adjustPageForZeroIndexing: function adjustPageForZeroIndexing(page) {
    return page - 1;
  },
  onPageChange: function onPageChange(evt) {
    this.props.updatePage(this.adjustPageForZeroIndexing(evt.target.value));
    (0, _jQuery.default)(document).scrollTop(0);
  },
  resetPageToZero: function resetPageToZero(newFilteringParams) {
    newFilteringParams.page = 0;
    return newFilteringParams;
  },
  onGoodFilterChange: function onGoodFilterChange(newFilteringParams) {
    this.props.updateGoodFilters(this.resetPageToZero(newFilteringParams));
  },
  trackDirectoryPageLinkClick: function trackDirectoryPageLinkClick(itemClicked) {
    this.props.trackClickedLink(_constants.Screens.DIRECTORY, itemClicked);
  },
  trackDirectoryAdjustedFilter: function trackDirectoryAdjustedFilter(filterType, value) {
    this.props.trackAdjustedFilter(_constants.Screens.DIRECTORY, filterType, value);
  },
  render: function render() {
    var _this$props = this.props,
        auth = _this$props.auth,
        directoryData = _this$props.directoryData,
        location = _this$props.location,
        categoryFilter = _this$props.categoryFilter;
    return _react.default.createElement(_UIListingPage.default, {
      headerComponent: _react.default.createElement(_AppHeader.default, {
        currentTab: _HeaderTabs.default.STOREFRONT,
        searchBarComponent: _react.default.createElement(_SearchBarContainer.default, {
          appliedSearchTerm: location.query.searchTerm || '',
          screen: "directory",
          categoryFilter: categoryFilter
        })
      }),
      pageLayout: "full-width",
      "data-selenium-selector": "directory-container"
    }, _react.default.createElement(_DirectoryPage.default, {
      auth: auth,
      directoryData: directoryData,
      onPageChange: this.onPageChange,
      onGoodFilterChange: this.onGoodFilterChange,
      trackAdjustedFilter: this.trackDirectoryAdjustedFilter,
      trackLinkClick: this.trackDirectoryPageLinkClick,
      categoryFilter: categoryFilter
    }));
  }
});

function mapStateToProps(state) {
  return {
    auth: state.auth,
    directoryData: state.directoryData,
    categoryFilter: state.directoryData.getIn(['goodFiltersAndPage', _GoodFiltersAndPage.default.SUB_TYPE])
  };
}

var mapDispatchToProps = {
  getGoodsWithFilterAndPageParamsFromUrl: _GoodsActions.getGoodsWithFilterAndPageParamsFromUrl,
  updatePage: _GoodsActions.updatePage,
  updateGoodFilters: _GoodsActions.updateGoodFilters,
  replace: _reactRouterRedux.replace
};

var _default = (0, _redux.compose)((0, _withUsageTracking.default)(), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(DirectoryContainer);

exports.default = _default;
module.exports = exports.default;